/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Remove_ButtonInputs */

const en_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const fr_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const it_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere`)
};

const ru_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалять`)
};

const es_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const zh_cn2_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消除`)
};

const ja_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り除く`)
};

const hi_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निकालना`)
};

const pt_pt2_style_guide_manager_remove_button = /** @type {(inputs: Style_Guide_Manager_Remove_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Style_Guide_Manager_Remove_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_remove_button = /** @type {((inputs?: Style_Guide_Manager_Remove_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Remove_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_remove_button(inputs)
	if (locale === "de") return de_style_guide_manager_remove_button(inputs)
	if (locale === "it") return it_style_guide_manager_remove_button(inputs)
	if (locale === "ru") return ru_style_guide_manager_remove_button(inputs)
	if (locale === "es") return es_style_guide_manager_remove_button(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_remove_button(inputs)
	if (locale === "ja") return ja_style_guide_manager_remove_button(inputs)
	if (locale === "hi") return hi_style_guide_manager_remove_button(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_remove_button(inputs)
	return en_style_guide_manager_remove_button(inputs)
});